<div class="manual-layout-container">
  <!-- Planogram Drops -->
  <div class="drops manual-mode">
    @for (drop of layout?.drops; track dropIndex; let dropIndex = $index) {
      <app-planogram-manual-drop
        [drop]="drop"
        [dropIndex]="dropIndex"
        [startingShelfNumber]="getStartingShelfNumber(dropIndex)"
        [style]="getDropStyle(dropIndex)">
      </app-planogram-manual-drop>
    }
  </div>
</div>